<template>
  <div class="view-wrapper">
    <div class="search-bar-list pd-btm0">
      <div class="search-filter">
        <div class="search-filter-input">
          <van-search
            v-model="keyword"
            shape="round"
            background="#ffffff"
            placeholder="输入医院/科室/医生搜索"
            :clearable="false"
            @input="searchDoctor"
          />
        </div>
        <div class="search-filter1">
          <van-button
            round
            type="info"
            :disabled="searchDisable"
            :loading="loading && resetDisable"
            class="search-filter-button"
            color="#aa341b"
            @click="searchDoctor"
          >
            搜索
          </van-button>
          <van-button
            round
            plain
            type="info"
            class="search-filter-button"
            color="#aa341b"
            :disabled="resetDisable"
            :loading="loading && searchDisable"
            @click="reset"
          >
            重置
          </van-button>
        </div>
      </div>
    </div>
    <div
      style="background-color: #f2f5f9; text-align: center;"
      class="index-list-wrapper custom"
      :class="{'no-list': list.length === 0}"
    >
      <van-list
        v-model="listLoading"
        :finished="finished"
        :immediate-check="false"
        :finished-text="$t('no_more_txt')"
        @load="onLoad"
      >
        <CardItem
          v-for="(item, index) in list"
          :id="'ITEM' + index"
          :ref="index === 0 ? 'AIMREF' : ''"
          :key="item.product_id + '_' + item.physician_id + index"
          :style="
            selectedItems?.includes?.(item.physician_id)
              ? {border: '1px solid #aa341b'}
              : {}
          "
          :is-favorite="true"
          :gen-status="false"
          :show-draw="false"
          :item="item"
          :parting="item.result"
          :physician-segment="item.physician_segment"
          @refreshFn="pageFn"
          @clickItem="selectItem(item)"
        />
      </van-list>
      <div v-if="!loading && list.length === 0" style="font-size: 14px; color: #a7a6a6; margin-top: 60px">
        <div style="margin-bottom: 30px;">请通过搜索寻找您要添加的医生</div>
      </div>
      <div style="height: 50px"></div>
    </div>
  </div>
</template>

<script>
import * as py from '@/api/Physicians';
import {List, Search, Button} from 'vant';
import {getLocalStorage} from '@/utils/index';
import CardItem from '@/views/hcp/components/CardItem';

export default {
  components: {
    CardItem,
    vanList: List,
    vanSearch: Search,
    vanButton: Button,
  },
  props: {
    onSelectItem: {
      type: Function,
      default: null,
    },
    selectedItems: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      keyword: '',
      loading: false,
      list: [],
      listLoading: false,
      finished: false,
      pageNum: 1,
      searchKey: '',
      physician_count: 0,
      searchDisable: false,
      resetDisable: false,
      sortOrder: 'physician_name',
    };
  },
  created() {
    this.pageFn(true);
  },
  methods: {
    pageFn() {
      const data = {
        user_id: getLocalStorage('user_id'),
        page_index: this.pageNum,
        page_size: 20,
        is_target: ['true'],
        search_key: this.searchKey,
      };
      if (
        this.pageNum === 1 ||
        (this.pageNum - 1) * data.page_size < this.physician_count
      ) {
        this.loading = true;
        py.newGetPhysicianList(data, this.sortOrder)
          .then((res) => {
            this.loadList(res);
          })
          .catch(() => {
            this.clearData();
          });
      } else {
        this.finished = true;
        this.listLoading = false;
      }
    },
    loadList(res) {
      const responseList = res?.data || [];
      if (res?.data_count !== undefined) {
        this.physician_count = res.data_count;
      }
      if (responseList.length > 0) {
        responseList.forEach((item) => {
          this.list.push(item);
        });
      } else {
        if (this.pageNum === 1) {
          this.list = [];
          this.physician_count = 0;
        }
        this.finished = true;
      }
      if (this.list.length >= this.physician_count) {
        this.finished = true;
      }
      this.loading = false;
      this.listLoading = false;
      this.searchDisable = false;
      this.resetDisable = false;
    },
    clearData() {
      this.listLoading = false;
      this.loading = false;
      this.searchDisable = false;
      this.resetDisable = false;
      this.list = [];
    },
    onLoad() {
      if (!this.loading) {
        this.pageNum++;
        this.listLoading = true;
        this.pageFn();
      }
    },
    selectItem(item) {
      if (this.onSelectItem) {
        this.onSelectItem(item);
      }
    },
    searchDoctor() {
      this.physician_count = 0;
      this.list = [];
      this.pageNum = 1;
      this.finished = false;
      this.listLoading = false;
      this.searchKey = this.keyword;
      this.resetDisable = true;
      this.pageFn(true);
    },
    reset() {
      this.physician_count = 0;
      this.list = [];
      this.pageNum = 1;
      this.finished = false;
      this.keyword = '';
      this.searchKey = '';
      this.searchDisable = true;
      this.pageFn(true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/follow-list.scss';

.search-bar-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  background: #fff;

  &.pd-btm0 {
    padding-bottom: 0;
  }
}

.search-filter {
  width: 100%;
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  align-items: center;
  padding: 0 10px;
}

.search-filter-input {
  width: calc(100% - 168px);
}

.search-filter1 {
  display: flex;
  align-items: center;
}

.search-filter-button {
  width: 72px;
  margin-left: 8px;
}
</style>
